import React, {Component} from 'react'
import { observer } from 'mobx-react'
import liqpayGeneratorStore from "../../store/LiqpayGeneratorStore";
import {LQ_KEYBOARD, LQ_STEPS, LQ_STEPS_TITLE} from "../../config/constants";

@observer
class LiqpaySumInput extends Component {
    render() {
        return (
            <div className='sum-input' >
                <div className='sum-visualizer'>
                    <div className='sum-sum'>{liqpayGeneratorStore.sumStr}</div>
                    <div className='sum-currency' >₴</div>
                </div>
                <div className='sum-keyboard' >
                    <div className='row' >
                        {
                            LQ_KEYBOARD.map(
                                item =>
                                    <div className='col-4 key' >
                                        <div className='inner' onClick={()=>liqpayGeneratorStore.sumKeyPress(item)}>
                                            {item}
                                        </div>
                                    </div>
                            )
                        }
                    </div>
                </div>
                <div className='sum-accept' >
                    <button
                        disabled={parseFloat(liqpayGeneratorStore.sumStr) === 0}
                        onClick={() => liqpayGeneratorStore.loadAccept()}
                    >Далі</button>
                </div>
            </div>
        )
    }
}

export default LiqpaySumInput
